// extracted by mini-css-extract-plugin
module.exports = {"item":"compare-bar-item-module--item--3gdRL","meta":"compare-bar-item-module--meta--tUcYc","close":"compare-bar-item-module--close--3Td1_"};